import httpClient from "../../../httpClient";
import { API_COMMENT_DELETE } from "../../../config";

export const deleteComment = {
    delete: (id) => httpClient.delete(API_COMMENT_DELETE + '/' + id),
};